import ApiService from "src/util/api.service";
import { getLanguageHeaders } from "./commonLanguageHeader";
import { ServicesUrlEndpoints } from "./servicesEndpointConstant";

export type AuditLogCategory = "DEVICE" | "UNIT" | "RELAY" | "USER" | "GEOFENCE";

export interface AuditLogParams {
  page: number;
  size: number;
  category?: AuditLogCategory;
  operation?: string;
  username?: string;
  vehicle_id?: string | number;
  target_type?: string;
  target_id?: string | number;
  from?: string;
  to?: string;
  limit?: number;
}

export interface AuditLogRecord {
  event_id: string;
  schema_version: number;
  category: string;
  operation: string;
  target_type: string;
  target_id: string;
  vehicle_id: number | null;
  username: string;
  created_at: string;
  description: string;
}

export interface AuditLogResponse {
  events: AuditLogRecord[];
  pagination: {
    page: number;
    size: number;
    total_elements: number;
    total_pages: number;
  };
}

export type AuditLogListParams = AuditLogParams;

export const getAuditLogs = (params: AuditLogParams, language?: string) =>
  ApiService.get<AuditLogResponse>(ServicesUrlEndpoints.AUDIT_LOG.LIST, {
    params,
    ...getLanguageHeaders(language),
  });

export const getAuditLog = getAuditLogs;
